module.exports = __webpack_public_path__ + "static/media/LCD_2.435e219b.svg";